/* eslint-disable @typescript-eslint/naming-convention */
//deps
import { useCallback, useContext } from "react";

// internal-deps
import { CappingModes } from "@swiggy-private/native-bridge";
import { getBridgeSdk } from "@swiggy-private/checkout-core";

// interfaces
import { RawApiResponse } from "@cart-client/interfaces/Api";

// hooks
import { useCbccNudgeAnalytics } from "./useCbccNudgeAnalytics";

// contexts
import { CartContext } from "@cart-client/contexts/CartContext";

export interface UseCbccWidgetDataReturnType {
    applicableDiscount?: number;
    recordCbccInterest?: () => Promise<RawApiResponse>;
    impressionCbccNudge: (dv: string, bi: string) => void;
    clickCbccNudge: (dv: string, bi: string) => void;
    impressionCbccThankyouCrouton: (bi: string) => void;
    impressionCbccResponseReceived: (bi: string) => void;
    updateFrequencyCount: (cappingMode: CappingModes, entityId: string, entityType: string) => void;
    logClevertapEvent: (eventName: string, params: Record<string, string>) => void;
}

export const useCbccWidgetData = (): UseCbccWidgetDataReturnType => {
    const { cartState } = useContext(CartContext);
    const { reviewedCart: cartResponse } = cartState;

    const updateFrequencyCount = useCallback((cappingMode: CappingModes, entityId: string, entityType: string) => {
        getBridgeSdk()
            .updateFrequencyCounter({
                cappingMode,
                entityId,
                entityType,
            })
            .catch(() => void 0);
    }, []);

    const logClevertapEvent = useCallback((eventName: string, params: Record<string, string>) => {
        getBridgeSdk()
            .logClevertapEvent({
                eventName,
                params,
            })
            .catch(() => void 0);
    }, []);

    const {
        impressionCbccNudge,
        clickCbccNudge,
        impressionCbccThankyouCrouton,
        impressionCbccResponseReceived,
    } = useCbccNudgeAnalytics();

    return {
        updateFrequencyCount,
        logClevertapEvent,
        impressionCbccNudge,
        clickCbccNudge,
        impressionCbccResponseReceived,
        impressionCbccThankyouCrouton,
        applicableDiscount: cartResponse?.data?.cbccWidgetAmount,
    };
};
